export { default } from './CognitoForm';
export { default as adapter } from './adapter';
